import { Image } from "antd";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

const SMALL_SIZE_FOR_ROUTES = ["/dashboard", "/order/add"];

export default function DataNotFound({ message = "", textSize=16 }) {
  const url = useLocation();
  const [containerHeight, setCotnainerHeight] = useState("h-[70vh]");

  useEffect(() => {
    if (SMALL_SIZE_FOR_ROUTES.includes(url.pathname)) {
      setCotnainerHeight("h-[30vh]");
    }
  }, []);

  return (
    <div
      className={`flex flex-col items-center justify-center text-3xl ${containerHeight}`}
    >
      <Image
        src={"/images/icons/no-pic-icon.svg"}
        alt="NoPic"
        preview={false}
      />
      <div className={`mt-[43.4px] font-p_semibold text-[${textSize}px] text-[#341557]`}>
        {message !== "" ? (
          <div>{message}</div>
        ) : (
          <div>
            <span className="text-black">Data </span>
            <span className="text-[#FCBD10]">Not Found !</span>
          </div>
        )}
      </div>
    </div>
  );
}
